import React from 'react';

import { Panel } from '@shared/components/bootstrap';
import { InputFormControl } from '@shared/components/fields/input_form_control';

import { SelectFormControl } from '@admin/components/fields';

const REGION_FILTER_ID = 'dispatcher-region';
const DATE_FILTER_ID = 'dispatcher-date';

type RegionOption = {
  id: string;
  name: string;
};

type DispatcherFiltersProps = {
  regions: RegionOption[];
  regionsLoading: boolean;
  regionID: string;
  date: string;
  disabled?: boolean;
  actions?: React.ReactNode;
  onRegionChange: (value: string | undefined) => void;
  onDateChange: (value: string | undefined) => void;
};

export const DispatcherFilters: React.FC<DispatcherFiltersProps> = ({
  regions,
  regionsLoading,
  regionID,
  date,
  disabled = false,
  actions,
  onRegionChange,
  onDateChange,
}) => (
  <div className="dispatcher-filters">
    <Panel>
      <Panel.Body>
        <div className="clearfix">
          {actions && <div className="pull-right">{actions}</div>}
          <div className="pull-left">
            <form className="form-inline">
              <div className="form-grouping">
                <SelectFormControl
                  id={REGION_FILTER_ID}
                  prompt=" - Region - "
                  aria-label="Dispatcher region"
                  options={regions.map((region) => region.id)}
                  value={regionID}
                  disabled={disabled || regionsLoading}
                  name={(regionId) => regions.find((region) => region.id === regionId)?.name ?? regionId}
                  onChange={onRegionChange}
                />
              </div>
              <div className="form-grouping">
                <InputFormControl
                  id={DATE_FILTER_ID}
                  className="form-control-fit"
                  type="date"
                  aria-label="Dispatcher date"
                  value={date}
                  disabled={disabled}
                  onChange={(event) => onDateChange(event.target.value || undefined)}
                />
              </div>
            </form>
          </div>
        </div>
      </Panel.Body>
    </Panel>
  </div>
);
